export default __webpack_public_path__ + "static/media/480_dummy2016-psychotherapie01-mobile-de.8b6ae0f9.png";